import { DataFeed, Client, BannerSet, BannerSize } from '../types';
import { BANNER_SIZES } from './bannerSizes';
import { v4 as uuidv4 } from 'uuid';

export const SAMPLE_DATA_FEED: DataFeed = {
  vehicle_year: "2025",
  model: "Accord Hybrid Sport",
  price: "$526",
  term: "36 months",
  due_at_signing: "$2,000",
  apr: "2.99%",
  apr_term: "36 months",
  image_url: "https://images.pexels.com/photos/3729464/pexels-photo-3729464.jpeg?auto=compress&cs=tinysrgb&w=800",
  disclaimer: "Lease for 36 months. $2,000 due at signing. Available to well-qualified lessees."
};

export const SAMPLE_DATA_FEED_2: DataFeed = {
  vehicle_year: "2025",
  model: "Accord SE",
  price: "$421",
  term: "36 months",
  due_at_signing: "$2,000",
  apr: "3.99%",
  apr_term: "60 months",
  image_url: "https://images.pexels.com/photos/1805053/pexels-photo-1805053.jpeg?auto=compress&cs=tinysrgb&w=800",
  disclaimer: "Lease for 36 months. $2,000 down payment. Available to well-qualified lessees."
};

export const SAMPLE_DATA_ARRAY: DataFeed[] = [
  SAMPLE_DATA_FEED,
  SAMPLE_DATA_FEED_2,
  {
    vehicle_year: "2025",
    model: "CR-V Hybrid Sport",
    price: "$419",
    term: "36 months",
    due_at_signing: "$1,500",
    apr: "3.49%",
    apr_term: "36 months",
    image_url: "https://images.pexels.com/photos/2920064/pexels-photo-2920064.jpeg?auto=compress&cs=tinysrgb&w=800",
    disclaimer: "Lease for 36 months. $1,500 due at signing. Available to well-qualified lessees."
  },
  {
    vehicle_year: "2025",
    model: "Pilot TrailSport",
    price: "$674",
    term: "36 months",
    due_at_signing: "$3,000",
    apr: "3.99%",
    apr_term: "36 months",
    image_url: "https://images.pexels.com/photos/1592384/pexels-photo-1592384.jpeg?auto=compress&cs=tinysrgb&w=800",
    disclaimer: "Lease for 36 months. $3,000 due at signing. Available to well-qualified lessees."
  }
];

// Create banner sizes with empty elements
const createEmptyBannerSizes = (): BannerSize[] => {
  return BANNER_SIZES.map(size => ({
    ...size,
    elements: [],
    lastModified: new Date()
  }));
};

export const SAMPLE_BANNER_SETS: BannerSet[] = [
  {
    id: uuidv4(),
    name: 'Honda Holiday Specials 2025',
    description: 'Holiday promotional banners for Honda vehicles',
    sizes: createEmptyBannerSizes(),
    dataFeed: SAMPLE_DATA_ARRAY[0],
    dataFeedArray: SAMPLE_DATA_ARRAY,
    createdAt: new Date('2024-11-01'),
    lastModified: new Date(),
    status: 'active'
  },
  {
    id: uuidv4(),
    name: 'Year-End Clearance',
    description: 'Year-end clearance event banners',
    sizes: createEmptyBannerSizes(),
    dataFeed: null,
    dataFeedArray: [],
    createdAt: new Date('2024-10-15'),
    lastModified: new Date('2024-11-20'),
    status: 'draft'
  },
  {
    id: uuidv4(),
    name: 'Spring Sales Event',
    description: 'Spring promotional campaign',
    sizes: createEmptyBannerSizes(),
    dataFeed: null,
    dataFeedArray: [],
    createdAt: new Date('2024-09-01'),
    lastModified: new Date('2024-09-15'),
    status: 'archived'
  }
];

export const SAMPLE_CLIENTS: Client[] = [
  {
    id: 'client-1',
    name: 'Inver Grove Honda',
    email: 'marketing@invergrove.honda.com',
    role: 'client',
    bannerSets: SAMPLE_BANNER_SETS,
    createdAt: new Date('2024-01-15'),
    lastLogin: new Date(),
    isActive: true
  },
  {
    id: 'client-2',
    name: 'Metro Honda',
    email: 'ads@metrohonda.com',
    role: 'client',
    bannerSets: [
      {
        id: 'set-metro-1',
        name: 'Black Friday Deals',
        description: 'Black Friday promotional banners',
        sizes: createEmptyBannerSizes(),
        dataFeed: null,
        dataFeedArray: [],
        createdAt: new Date('2024-11-01'),
        lastModified: new Date(),
        status: 'active'
      }
    ],
    createdAt: new Date('2024-02-01'),
    lastLogin: new Date('2024-12-10'),
    isActive: true
  },
  {
    id: 'client-3',
    name: 'Downtown Honda',
    email: 'creative@downtownhonda.com',
    role: 'client',
    bannerSets: [],
    createdAt: new Date('2024-03-10'),
    lastLogin: new Date('2024-11-25'),
    isActive: false
  },
  {
    id: 'client-4',
    name: 'Suburban Honda',
    email: 'marketing@suburbanhonda.com',
    role: 'client',
    bannerSets: [
      {
        id: 'set-suburban-1',
        name: 'New Model Showcase',
        description: 'Showcasing 2025 Honda models',
        sizes: createEmptyBannerSizes(),
        dataFeed: SAMPLE_DATA_ARRAY[0],
        dataFeedArray: SAMPLE_DATA_ARRAY.slice(0, 2),
        createdAt: new Date('2024-10-01'),
        lastModified: new Date('2024-11-15'),
        status: 'active'
      },
      {
        id: 'set-suburban-2',
        name: 'Service Specials',
        description: 'Service department promotions',
        sizes: createEmptyBannerSizes(),
        dataFeed: null,
        dataFeedArray: [],
        createdAt: new Date('2024-11-01'),
        lastModified: new Date('2024-11-20'),
        status: 'draft'
      }
    ],
    createdAt: new Date('2024-01-20'),
    lastLogin: new Date('2024-12-01'),
    isActive: true
  }
];